import { api, giftApi, recordApi, transferApi, userApi } from "./baseApi";

export const toggleFavoriteGame = ({ params, gameUid }) => {
  const { status } = params;
  return userApi.put(`/toggleFavoriteGame/${gameUid}`, {
    status: status,
  });
}; //切换我的最爱状态
